import { render } from "./ForumThreadDetail.vue?vue&type=template&id=2e491061&scoped=true"
import script from "./ForumThreadDetail.vue?vue&type=script&lang=js"
export * from "./ForumThreadDetail.vue?vue&type=script&lang=js"

import "./ForumThreadDetail.vue?vue&type=style&index=0&id=2e491061&scoped=true&lang=css"
import "./ForumThreadDetail.vue?vue&type=style&index=1&id=2e491061&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e491061"]])

export default __exports__